import { DropdownOptionProps } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';
import { TIMEZONES_LIST } from 'src/utilities/timeZones';

export const timeZoneOptions: DropdownOptionProps[] = TIMEZONES_LIST.map(
  ({ id: value, name: text }) => ({ text, value })
);
